import { render } from "./EventDetails.vue?vue&type=template&id=8c2fb1a0&scoped=true"
import script from "./EventDetails.vue?vue&type=script&lang=js"
export * from "./EventDetails.vue?vue&type=script&lang=js"

import "./EventDetails.vue?vue&type=style&index=0&id=8c2fb1a0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8c2fb1a0"

export default script